import { sessionStorageUtil } from "../utils/storage";

export const getInvestorRequests = async (data) => {
  const token = sessionStorageUtil.getAccessToken();
  const code = sessionStorageUtil.getAmcCode();

  const { email, folio_no, request_status, activePageNumber, signal } = data;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/investor-requests/by-folio?email=${encodeURIComponent(email)}&folio_no=${encodeURIComponent(folio_no)}&amc_code=${encodeURIComponent(code)}&request_status=${request_status}&status=true&page_number=${activePageNumber}`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        signal,
      },
    );

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data.message);
    }

    return {
      data,
      message: data.message,
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message,
      error: true,
    };
  }
};
